import React from 'react';

// Phase B Wave 2.4: \uC18C\uC720\uC790 \uAD11\uACE0 \uB3D9\uC758 \uC644\uB8CC \uBCA0\uC9C0
// TrustBadge \uD328\uD134 \uC7AC\uC0AC\uC6A9 (pill \uD615\uD0DC)
// owner_consent_given=1 && owner_consent_method \uC874\uC7AC\uC2DC \uB80C\uB354
// method \uB77C\uBCA8:
//   in_person  \u2192 \uBA74\uB300\uBA74
//   written    \u2192 \uC11C\uBA74
//   electronic \u2192 \uC804\uC790
//   self_owner \u2192 \uBCF8\uC778 (\uCC28\uC8FC == \uAE30\uC85D\uC778, \uBCC4\uB3C4 \uB3D9\uC758 \uBD88\uD544\uC694)
//   delegated  \u2192 \uC704\uC784

var METHOD_LABELS = {
  in_person: '\uBA74\uB300\uBA74',
  written: '\uC11C\uBA74',
  electronic: '\uC804\uC790',
  self_owner: '\uBCF8\uC778',
  delegated: '\uC704\uC784'
};

function ConsentBadge(props) {
  var given = props.ownerConsentGiven;
  var method = props.ownerConsentMethod;
  var size = props.size || 'sm';
  if (!given) return null;

  var label = (method && METHOD_LABELS[method]) || '\uB3D9\uC758\uC644\uB8CC';
  var text = '\uB3D9\uC758\uC644\uB8CC' + (method && METHOD_LABELS[method] ? ' (' + METHOD_LABELS[method] + ')' : '');

  var fontSize = size === 'lg' ? 13 : size === 'md' ? 12 : 11;
  var padY = size === 'lg' ? 4 : 3;
  var padX = size === 'lg' ? 10 : 8;
  var baseColor = '#0ea5e9';  // \uD558\uB298\uC0C9 \u2014 "\uBCF4\uD638/\uC2E0\uB8B0"
  var bg = baseColor + '22';
  var border = '1px solid ' + baseColor + '55';

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: padY + 'px ' + padX + 'px', borderRadius: 9999,
      background: bg, border: border, color: baseColor,
      fontSize: fontSize, fontWeight: 700, whiteSpace: 'nowrap', lineHeight: 1
    }} aria-label={text} title={text}>
      <span style={{ fontSize: fontSize }}>\uD83D\uDD12</span>
      <span>{text}</span>
    </span>
  );
}

export default ConsentBadge;
